// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"0":"auflage-3","60":"auflage-2","78":"auflage-1","129":"autoren","773":"kapitel"}[chunkId] || chunkId) + "." + {"0":"9e497072","60":"1916e1b1","78":"f2dafda3","129":"da84e390","134":"8f693799","773":"a49f28c6"}[chunkId] + ".css";
};